/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlLoginIPOrderByMethods = {
    Timestamp: 'timestamp'
} as const;
export type ControlLoginIPOrderByMethods = typeof ControlLoginIPOrderByMethods[keyof typeof ControlLoginIPOrderByMethods];


export function ControlLoginIPOrderByMethodsFromJSON(json: any): ControlLoginIPOrderByMethods {
    return ControlLoginIPOrderByMethodsFromJSONTyped(json, false);
}

export function ControlLoginIPOrderByMethodsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlLoginIPOrderByMethods {
    return json as ControlLoginIPOrderByMethods;
}

export function ControlLoginIPOrderByMethodsToJSON(value?: ControlLoginIPOrderByMethods | null): any {
    return value as any;
}

